import {
  Button,
  CardHeader,
  DataGrid,
  Dialog,
  DialogActions,
  DialogContent,
} from "../../../../components";

const CodigoBarraRepetidosDialog = ({
  open,
  setOpen,
  produtosCodigosRepitidos,
  handleInitStep,
}) => {
  const colunasProdutos = [
    {
      field: "codigoBarra",
      headerName: "Código de Barra",
      sortable: false,
      flex: 200,
    },
    {
      field: "descricao",
      headerName: "Produto",
      sortable: false,
      flex: 400,
    },
  ];
  
  function onClose() {
    handleInitStep();
    setOpen(false);
  }

  return (
    <Dialog fullWidth maxWidth={"md"} open={open} onClose={onClose}>
      <CardHeader title="CODIGO DE BARRAS REPETIDOS" className="m-2" />
      <DialogContent>
        <DataGrid
          rows={produtosCodigosRepitidos}
          columns={colunasProdutos}
          rowCount={produtosCodigosRepitidos.length}
          disableAcoes
        />
      </DialogContent>
      <DialogActions
        sx={{
          overflow: "auto",
          position: "sticky",
          bottom: 0,
          margin: 1,
          backgroundColor: "white",
        }}
      >
        <Button
          color="padrao"
          margin="normal"
          variant="contained"
          onClick={onClose}
          disableElevation
        >
          <i
            className="ph-fill ph-x-circle"
            style={{ fontSize: 22, marginRight: 10 }}
          ></i>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CodigoBarraRepetidosDialog;
